module.exports = __webpack_public_path__ + "onboarding-proxies.510fe53a8f92c740be292743e8389b83.hashedasset.svg";